// extracted by mini-css-extract-plugin
export default {"error_page":"ErrorPage_error_page__A7Zmr","main_container":"ErrorPage_main_container__pgtaC","title":"ErrorPage_title__SEONk"};